import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionBoardComponent } from 'src/app/features/create-questionnaire-page/component/question-board/question-board.component';
import { StepsMenuComponent } from 'src/app/features/create-questionnaire-page/component/steps-menu/steps-menu.component';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AnswersStore } from 'src/app/store/answers-store';
import { GlobalStore } from 'src/app/store/global-store';
import { LoadingBoardComponent } from '../../create-questionnaire-page/component/loading-board/loading-board';
import { BoardHeaderComponent } from '../../create-questionnaire-page/component/board-header/board-header.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { DragStore } from 'src/app/store/drag-store';
import { ViewAnswerHeaderComponent } from "../../view-answers/view-answer-header/view-answer-header.component";

@Component({
    selector: 'que-preview',
    imports: [CommonModule, QuestionBoardComponent, BoardHeaderComponent, TranslateDirective, TranslatePipe, LoadingBoardComponent, StepsMenuComponent, SvgIconComponent, ViewAnswerHeaderComponent],
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviewComponent implements OnInit {
  @ViewChild('warpBoard', { static: true }) warpBoard!: ElementRef;
  @Input() viewAnswer:boolean = false;
  isUser$ = toSignal(inject(QuestionnaireStore).isUser$);
  // #activeRoutes = inject(ActivatedRoute);
  #questionnaireStore = inject(QuestionnaireStore);
  #answersStore = inject(AnswersStore);
  #dragStore = inject(DragStore);
  notLoading$ = toSignal(this.#questionnaireStore.notLoading$);
  answeload$ = toSignal(inject(AnswersStore).loading$);
  globalansweload$ = toSignal(inject(GlobalStore).loadingAnswer$);
  backColor$ = this.#questionnaireStore.backColor$;
  currentStepIndex$ = toSignal(this.#questionnaireStore.currentStepIndex$);
  stepsLength$ = toSignal(this.#questionnaireStore.stepsLength$);
  isOpenPageMenu = false;

  goToBottomEvent$ = inject(DragStore).goToBottomEvent$;
  goToTopEvent$ = inject(DragStore).goToTopEvent$;

  ngOnInit(): void {
    this.goToBottomEvent$.subscribe(t => {
      if (t) {
        this.scrollToBottom();
        this.#dragStore.goToBottom(false);
      }
    });

    this.goToTopEvent$.subscribe(t => {
      if (t) {
        this.scrollToTop();
        this.#dragStore.goToTop(false);
      }
    });
  }
  next() {
    if (this.currentStepIndex$() != undefined) {
      this.#answersStore.updateVisitedSteps(this.currentStepIndex$()!);
    }

    this.#questionnaireStore.nextStepIndex();
      this.#dragStore.goToTop(true);
  }
  prev() {
    if (this.currentStepIndex$() != undefined) {
      this.#answersStore.updateVisitedSteps(this.currentStepIndex$()!);
    }
    this.#questionnaireStore.prevStepIndex();
      this.#dragStore.goToTop(true);
  }

  openPagesMenu() {
    this.isOpenPageMenu = true;
  }
  closePagesMenu() {
    this.isOpenPageMenu = false;
  }

  isVisitedStep$ = toSignal(this.#answersStore.visitedSteps$);

  scrollToBottom() {
    setTimeout(() => {
      if (this.warpBoard) {
        this.warpBoard.nativeElement.scrollTop = this.warpBoard.nativeElement.scrollHeight ;
      }
    });
  }
  scrollToTop() {
    setTimeout(() => {
      if (this.warpBoard) {
        this.warpBoard.nativeElement.scrollTop = 0;
      }
    }
    );
  }
}
